const ga = {
    /** 適用event：view_item、remove_from_cart、add_to_cart、begin_checkout、view_cart
     * @param {Object} item - 資料內容
     */
    pushDataLayer(items){
        if(!items || items.length == 0) return;
        let ecommerceItems = [];
        _.forEach(items, i =>{
            ecommerceItems.push({
                item_id: i.item_id,
                item_name: i.item_name === 'Car' ? '汽車險' : '機車險',
                affiliation: '', 
                item_brand: '新安東京海上產物保險',
                item_category: i.item_category,
                item_category2: i.item_category2,
                item_category3: '',
                item_category4: '',
                item_category5: '',
                item_list_id: i.item_list_id,
                item_list_name: i.item_list_name,
                price: i.price,
                quantity: 1 //商品數量
            });
        });
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: items[0].event,
            ecommerce: {
                currency: 'TWD', //貨幣(ISO 4217格式)
                value: _.sumBy(ecommerceItems, 'price'), //保單預估總價格
                items: ecommerceItems
            }
        }); 
    },
    /** 適用event：select_item
     * @param {Object} item - 資料內容
     */
    pushDataLayerForSelectItem(item){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: item.event,
            ecommerce: {
                item_list_id: item.item_list_id, //推薦組合ID
                item_list_name: item.item_list_name, //推薦組合名稱
                items: [
                    {
                        item_id: item.item_id, //商品SKU
                        item_name: item.item_name === 'Car' ? '汽車險' : '機車險', //商品名稱
                        affiliation: '', //活動代碼(若無活動代碼可省略)
                        item_brand: '新安東京海上產物保險', //商品品牌
                        item_category: item.item_category, //商品類別
                        item_category2: item.item_category2, //商品類別2
                        item_category3: '', //商品類別3
                        item_category4: '', //商品類別4
                        item_category5: '', //商品類別5
                        item_list_id: item.item_list_id, //推薦組合ID
                        item_list_name: item.item_list_name,//推薦組合名稱
                        price: item.price, //保單預估總價格
                        quantity: 1 //商品數量
                    }
                ]
            }
        });
    },
    /** 適用event：purchase
     * @param {Object} item - 資料內容
     */
    pushDataLayerForPurchase(item){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: item.event,
            ecommerce: {
                transaction_id: item.transaction_id, //交易ID
                payment_phase: item.payment_phase,
                value: item.value,
                currency: 'TWD', //貨幣(ISO 4217格式)
                items: [
                    {
                        item_id: item.item_id, //商品SKU
                        item_name: item.item_name === 'Car' ? '汽車險' : '機車險', //商品名稱
                        affiliation: '', //活動代碼(若無活動代碼可省略)
                        item_brand: '新安東京海上產物保險', //商品品牌
                        item_category: item.item_category, //商品類別
                        item_category2: item.item_category2, //商品類別2
                        item_category3: '', //商品類別3
                        item_category4: '', //商品類別4
                        item_category5: '', //商品類別5
                        item_list_id: item.item_list_id, //推薦組合ID(若無推薦組合ID可略)
                        item_list_name: item.item_list_name, //推薦組合名稱
                        price: item.price, //保單試算結果網路價
                        quantity: 1 //商品數量
                    }
                ]
            }
        });
    },
    /** 適用event：login、sign_up
     * @param {Object} item - 資料內容
     */
    pushDataLayerForMember(item){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event : item.event,
            method : item.method
        });
    },
    /** 適用event：page_view
     * @param {Object} item - 資料內容
     */
    pushDataLayerForPageView(item){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'page_view_datalayer',
            pageUrl: item.pageUrl,
            pageTitle: item.pageTitle
        });
    },
};
export default ga;